import { render, staticRenderFns } from "./SMSConfirmation.vue?vue&type=template&id=dc88b0f4&"
import script from "./SMSConfirmation.vue?vue&type=script&lang=js&"
export * from "./SMSConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports